// extracted by mini-css-extract-plugin
export default {"root":"VideoPlayIcon-module-root-FPqcj","imageOverlay":"VideoPlayIcon-module-imageOverlay-GTlW2","rtl":"VideoPlayIcon-module-rtl-LY74E"};